// Fotografi uretilmis taki urunleri: urun gorselleri (ProductShot) + katalog
// kaydi + bu urunden acilmis taslaklar. Listing Builder ve Liste Denetimi
// ayni listeyi kullanir.

import { useQuery } from "@tanstack/react-query";
import { apiClient } from "./api";
import { authHeaders, getBackendUrl } from "./http";
import { productJewelryType } from "./jewelryType";
import type { ProductCategory, SupplierCatalog } from "@erc/shared";

export interface ShotProductDraft {
  id: string; title: string; status: string; etsyListingId: string | null; updatedAt: string;
}

export interface ShotProduct {
  /** "<catalogId>:<categoryId>" — URL'de de bu bicimde tasinir */
  key: string;
  catalogId: string;
  categoryId: string;
  catalogName: string;
  product: ProductCategory | null;
  name: string;
  /** Taki turu (kolye, kupe…) — katalogta secilen ya da addan tahmin */
  typeKey: string | null;
  shotCount: number;
  coverUrl: string;
  lastShotAt: string;
  drafts: ShotProductDraft[];
}

export const shotProductKey = (catalogId: string, categoryId: string) => `${catalogId}:${categoryId}`;

export function useShotProducts(enabled = true) {
  return useQuery({
    queryKey: ["shot-products"],
    enabled,
    staleTime: 30_000,
    queryFn: async (): Promise<{ items: ShotProduct[]; catalogs: SupplierCatalog[] }> => {
      const [res, catalogs] = await Promise.all([
        fetch(`${getBackendUrl()}/api/product-shots/products`, { headers: authHeaders() }).then((r) => (r.ok ? r.json() : { data: [] })),
        apiClient.listSupplierCatalogs("jewelry").catch(() => [] as SupplierCatalog[]),
      ]);
      const rows = (res?.data ?? []) as Array<Omit<ShotProduct, "key" | "catalogName" | "product" | "name" | "typeKey">>;
      const byId = new Map(catalogs.map((c) => [c.id, c]));
      const items = rows.map((r) => {
        const cat = byId.get(r.catalogId);
        const product = ((cat?.categories ?? []) as ProductCategory[]).find((p) => p.id === r.categoryId) ?? null;
        return {
          ...r,
          key: shotProductKey(r.catalogId, r.categoryId),
          catalogName: cat?.name ?? "",
          product,
          name: product?.name ?? r.categoryId,
          typeKey: productJewelryType(product as unknown as { productTypeKey?: string; name?: string }),
        };
      });
      return { items, catalogs };
    },
  });
}
